import Rete from 'rete';

import Action from './Action';
import { ACTION_OUTPUT_SOCKET } from '../SOCKETS';
import trackNodeHistory from '../utils/history/trackNodeHistory';

class ActionComponent extends Rete.Component {
  constructor(emitter) {
    super('Action');
    this.render = 'vue';
    this.data.component = Action;
    this.data.props = {};
    this.emitter = emitter;
  }

  builder = node => {
    const targets = new Rete.Output('targets', 'Do', ACTION_OUTPUT_SOCKET);

    node.addOutput(targets);
    trackNodeHistory(this, node, this.emitter);
  };
}

export default ActionComponent;
